import React, { useEffect, useState } from "react";

export default function Viewport({ children }) {
  return (
    <div style={{ height: "calc(100vh - 125px)", width: "100vw" }} className="h-fit">
      {children}
    </div>
  );
}
